import type { MetricResponse } from '@core/interfaces/metric.interface';

import { mockDb } from '../mock-db';

export function getActivityOverviewMock(): MetricResponse {
  return mockDb.getActivityOverview();
}

export function getActivityOverviewByRentalIdMock(_rentalId: string): MetricResponse {
  return mockDb.getActivityOverview();
}

export function getAccessMetricsMock(): MetricResponse {
  return mockDb.getAccessMetrics();
}
